import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { uniqBy } from 'lodash';

import Clear from '../icons/clear-btn.svg';
import { CustomCurrentRefinementItem } from './models';

import './CustomCurrentRefinements.scss';

const CurrentRefinements = ({ items, refine }) => {
  if (!items.length) return null;

  return (
    <ul className="current-refinement">
      {items?.map((item) =>
        item.items?.map((nested) => (
          <li key={nested.label} className="current-refinement__item">
            <button
              type="button"
              className="current-refinement__btn"
              onClick={() => {
                refine(nested.value);
              }}
            >
              <span className="current-refinement__btn-text breadcrumb">{nested.label}</span>
              <span className="current-refinement__btn-icon" aria-hidden="true">
                <Clear />
              </span>
            </button>
          </li>
        ))
      )}
    </ul>
  );
};

const deduplicate = (items) => uniqBy(items, (item: CustomCurrentRefinementItem) => item.attribute);

const CustomCurrent = connectCurrentRefinements(CurrentRefinements);

const CustomCurrentRefinements = () => <CustomCurrent transformItems={deduplicate} />;

export default CustomCurrentRefinements;
